import { render, staticRenderFns } from "./bsformu.vue?vue&type=template&id=769d0588&scoped=true"
import script from "./bsformu.vue?vue&type=script&lang=js"
export * from "./bsformu.vue?vue&type=script&lang=js"
import style0 from "./bsformu.vue?vue&type=style&index=0&id=769d0588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769d0588",
  null
  
)

export default component.exports